module.exports = __webpack_public_path__ + "media/conmex/rfcs-76b3ae05.png";